import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filledCompany: null,
  claimTradeLicenseDetails: null,
  claimAuthSignDetails: null,
  industryDetails: [],
  claimAddressDetails: null,
  claimContactDetails: null
};

const claimSlice = createSlice({
  name: "Claim",
  initialState,
  reducers: {
    setFilledCompany: (state, action) => {
      state.filledCompany = action.payload;
    },
    setClaimTradeLicenseDetails: (state, action) => {
      state.claimTradeLicenseDetails = action.payload;
    },
    setClaimAuthSignDetails: (state, action) => {
      state.claimAuthSignDetails = action.payload;
    },
    setIndustryDetails: (state, action) => {
      state.industryDetails = action.payload;
    },
    setClaimAddressDetails: (state, action) => {
      state.claimAddressDetails = action.payload;
    },
    setClaimContactDetails: (state, action) => {
      state.claimContactDetails = action.payload;
    },
    setClearClaimDetails: (state) => {
      state.filledCompany = null;
      state.claimTradeLicenseDetails = null;
      state.claimAuthSignDetails = null;
      state.industryDetails = [];
      state.claimAddressDetails = null;
      state.claimContactDetails = null;
    },
  },
});

export const {
  setFilledCompany,
  setClaimTradeLicenseDetails,
  setClaimAuthSignDetails,
  setIndustryDetails,
  setClaimAddressDetails,
  setClaimContactDetails,
  setClearClaimDetails
} = claimSlice.actions;

export default claimSlice.reducer;
